import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'phoneticColor'
})
export class PhoneticColorPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: string, args?: any): SafeHtml {
    if (value.indexOf(':') > 0) {
      const parts: string[] = [];
      parts[0] = value.substring(0, 11);
      parts[1] = value.charAt(12);
      parts[2] = value.substring(13);

      return this.domSanitizer.bypassSecurityTrustHtml(
        `${parts[0]}<span class="labelBlueBold">${parts[1]}</span>${parts[2]}`
      );
    }

    return this.domSanitizer.bypassSecurityTrustHtml(
      `<span class="labelBlueBold">${value}</span>`
    );
  }
}
